import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { Role } from 'my-lib-sanfelici';
import { RolesService } from 'my-lib-sanfelici';






@Component({
  selector: 'app-role-edit',
  templateUrl: './role-edit.component.html',
  styleUrls: ['./role-edit.component.css']
})
export class RoleEditComponent implements OnInit {
    role: Observable<Role>;
    constructor(
        private route: ActivatedRoute,
        private rolesservice: RolesService) { }

    ngOnInit() {
        const i = this.route.snapshot.params['id'];
        this.role = this.rolesservice.get(i);
  }

}
